<div class="sh-page-section">
    <sh-notification
        [type]="notificationType.Update"
        [title]="'components.not-found.title' | translate"
        [message]="'components.not-found.message' | translate"
    ></sh-notification>
</div>
